import React, { forwardRef, useEffect, useState, useRef } from "react";
import i18next from "i18next";
import { Grid, Typography, Box, Button, IconButton } from "@mui/material";
import LockIcon from "@mui/icons-material/Lock";
import BarChartIcon from "@mui/icons-material/BarChart";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import imgurl from "../assests/images/imgurl";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";

const LandingMiddlePage = ({ sectionRefs }) => {
  const [isFrOrEs, setIsFrOrEs] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const locale = useSelector((state) => state.language.langData);
  const navigate = useNavigate()

  const getTestUrl = () => {
    return `https://hairtest.alopexia.com/?lang=${locale}`;
  };

  useEffect(() => {
    if (!window.cordova) {
      let isMobile = /iPhone|iPod|iPad|Android/i.test(navigator.userAgent);
      if (!isMobile) {
        setIsMobile(false);
      } else {
        setIsMobile(true);
      }
    }
  }, [isMobile]);

  return (
    <>
      {/* content for web */}
      {!isMobile && (
        <section
          ref={sectionRefs.section1}
          id="home"
          className="hero section mt-40px"
          style={{ padding: "30px 45px" }}
        >
          {/* <Box className="container"> */}
          <Grid container spacing={4} className="mainHerowrapper">
            <Grid
              item
              xs={12}
              lg={6}
              className="heroLeftsection"
              // display="flex"
              // flexDirection="column"
              // justifyContent="center"
              // data-aos="fade-up"
            >
              <Typography
                variant="h4"
                className="textSpan"
                data-i18n="hero.title"
              >
                {i18next.t("Rooted in research. Personalised results.")}
              </Typography>

              <Typography
                variant="subtitle1"
                data-i18n="hero.subtitle"
                mt={2}
                className="supportText"
              >
                {i18next.t(
                  "Take our AI hair health test - backed by clinical standards"
                )}
              </Typography>

              <Typography
                variant="body1"
                className="snapSpan"
                data-i18n="hero.tagline"
                mt={2}
              >
                {i18next.t("Unlock Your Personalised Hair Insights")}
              </Typography>

              <Typography variant="body2" data-i18n="hero.description" mt={2}>
                {i18next.t(
                  "We use clinically validated scales to determine the impact of hair loss, hair thinning, inflammation, dandruff, and other underlying concerns on your hairline. Our AI then provides personalized treatment solutions to help improve your hair health."
                )}
              </Typography>

              {/* <Box className="feature-bar" mt={4} mb={3}>
              <Grid container spacing={2} alignItems="center">
                <Grid item className="feature-item">
                  <LockIcon fontSize="small" />
                  <Typography variant="caption" data-i18n="hero.features.privacy">
                    {i18next.t("100% Private")}
                  </Typography>
                  <div className="divider" />
                </Grid>
                <Grid item className="feature-item">
                  <BarChartIcon fontSize="small" />
                  <Typography variant="caption" data-i18n="hero.features.instantResults">
                    {i18next.t("Validated Results")}
                  </Typography>
                  <div className="divider" />
                </Grid>
                <Grid item className={isFrOrEs ? "extra-class feature-item" : "feature-item"}>
                  <CheckCircleIcon fontSize="small" />
                  <Typography variant="caption" data-i18n="hero.features.recommendations">
                    {i18next.t("Tailored Recommendations")}
                  </Typography>
                </Grid>
              </Grid>
            </Box>

            
            <Box display="flex" className="mobileFlex">
              <Button
                variant="contained"
                color="primary"
                href={getTestUrl()}
                target="_blank"
                data-i18n="hero.cta"
                className="btn-get-started"
              >
                {i18next.t("Take the Test")}
              </Button>
            </Box> */}
            </Grid>

            <Grid
              item
              xs={12}
              lg={6}
              className="heroRightsection"
              display="flex"
              flexDirection="column"
              justifyContent="center"
            >
              <Box className="feature-bar mt-0px" mt={4} mb={3}>
                <Grid
                  container
                  spacing={2}
                  alignItems="center"
                  flexDirection="row"
                >
                  <Grid item xs={12} lg={4} md={4} className="feature-item">
                    <div className="featureMainBox">
                      <LockIcon fontSize="small" />
                      <Typography
                        variant="caption"
                        data-i18n="hero.features.privacy"
                        className="caption"
                      >
                        {i18next.t("100%")} <br></br> {i18next.t("Private")}
                      </Typography>
                    </div>
                  </Grid>
                  <Grid item xs={12} lg={4} md={4} className="feature-item">
                    <div className="featureMainBox bg-white">
                      <BarChartIcon fontSize="small" />
                      <Typography
                        variant="caption"
                        data-i18n="hero.features.instantResults"
                        className="caption"
                      >
                        {i18next.t("Validated")} <br></br>{" "}
                        {i18next.t("Results")}
                      </Typography>
                    </div>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    lg={4}
                    md={4}
                    className={
                      isFrOrEs ? "extra-class feature-item" : "feature-item"
                    }
                  >
                    <div className="featureMainBox bg-lightBlue">
                      <CheckCircleIcon fontSize="small" />
                      <Typography
                        variant="caption"
                        data-i18n="hero.features.recommendations"
                        className="caption"
                      >
                        {i18next.t("Tailored")} {i18next.t("Recommendations")}
                      </Typography>
                    </div>
                  </Grid>
                </Grid>
              </Box>

              {/* <Box display="flex" className="mobileFlex">
              <Button
                variant="contained"
                color="primary"
                href={getTestUrl()}
                target="_blank"
                data-i18n="hero.cta"
                className="btn-get-started"
              >
                {i18next.t("Take the Test")}
              </Button>
            </Box> */}
            </Grid>
          </Grid>
          {/* </Box> */}
        </section>
      )}

      {/* content for mobile */}
      {isMobile && (
        <section
          ref={sectionRefs.section1}
          id="home"
          className="hero section"
          style={{ padding: "30px 45px" }}
        >
          {/* <Box className="container"> */}
          <Grid container spacing={4} className="mainHerowrapper">
            <Grid
              item
              xs={12}
              lg={6}
              className="heroLeftsection"
              // display="flex"
              // flexDirection="column"
              // justifyContent="center"
              // data-aos="fade-up"
            >
              <Typography
                variant="body1"
                className="snapSpan"
                data-i18n="hero.tagline"
                mt={2}
              >
                {i18next.t("Unlock Your Personalised Hair Insights")}
              </Typography>

              <Typography variant="body2" data-i18n="hero.description" mt={2}>
                {i18next.t(
                  "We use clinically validated scales to determine the impact of hair loss, hair thinning, inflammation, dandruff, and other underlying concerns on your hairline. Our AI then provides personalized treatment solutions to help improve your hair health."
                )}
              </Typography>

              <Typography
                variant="h4"
                className="textSpan"
                data-i18n="hero.title"
              >
                {i18next.t("Rooted in research. Personalised results.")}
              </Typography>
            </Grid>

            <div className="sectionOptionsWrapper">
              <Typography
                variant="subtitle1"
                data-i18n="hero.subtitle"
                mt={2}
                className="supportText"
              >
                {i18next.t(
                  "Take our AI hair health test - backed by clinical standards"
                )}
              </Typography>
              <Grid
                item
                xs={12}
                lg={6}
                className="heroRightsection"
                display="flex"
                flexDirection="column"
                justifyContent="center"
              >
                <Box className="feature-bar mt-0px" mt={4} mb={3}>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    flexDirection="row"
                  >
                    <Grid item xs={12} sm={4} lg={4} md={4} className="feature-item">
                      <div className="featureMainBox">
                        <LockIcon fontSize="small" />
                        <Typography
                          variant="caption"
                          data-i18n="hero.features.privacy"
                          className="caption"
                        >
                          {i18next.t("100%")} <br></br> {i18next.t("Private")}
                        </Typography>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={4} lg={4} md={4} className="feature-item">
                      <div className="featureMainBox bg-white">
                        <BarChartIcon fontSize="small" />
                        <Typography
                          variant="caption"
                          data-i18n="hero.features.instantResults"
                          className="caption"
                        >
                          {i18next.t("Validated")} <br></br>{" "}
                          {i18next.t("Results")}
                        </Typography>
                      </div>
                    </Grid>
                    <Grid item xs={12} lg={4} sm={4} md={4} className={
                        isFrOrEs ? "extra-class feature-item" : "feature-item"
                      }
                    >
                      <div className="featureMainBox bg-lightBlue">
                        <CheckCircleIcon fontSize="small" />
                        <Typography
                          variant="caption"
                          data-i18n="hero.features.recommendations"
                          className="caption"
                        >
                          {i18next.t("Tailored")} {i18next.t("Recommendations")}
                        </Typography>
                      </div>
                    </Grid>
                  </Grid>
                </Box>

                {/* <Box display="flex" className="mobileFlex">
              <Button
                variant="contained"
                color="primary"
                href={getTestUrl()}
                target="_blank"
                data-i18n="hero.cta"
                className="btn-get-started"
              >
                {i18next.t("Take the Test")}
              </Button>
            </Box> */}
              </Grid>
               <div className="w-100">
            <h6 className='buttonTakeTest mt-20px' onClick={() => {
                  // setTakeTest(true)
                  navigate('/loginpage')
                }}>{i18next.t("Take the AI Hair Test")}</h6>
                </div>      
            </div>

           
          </Grid>
          {/* </Box> */}
        </section>
      )}

      <section
        ref={sectionRefs.section2}
        className="workSectionMain mb-0"
        id="how-it-works"
        style={{ padding: "25px 45px" }}
      >
        <Box className="container section-title">
          <h2 data-i18n="howItWorks.title">
            {i18next.t("Hair Health Insights in 3 Simple Steps")}
          </h2>
        </Box>

        <Box className="container mb-2">
          <Grid
            container
            spacing={2}
            justifyContent="center"
            textAlign="center"
          >
            <Grid item xs={12} md={4} sm={4} className="step-box position-relative">
              <Box className="icon-box">
                <img src={imgurl.cameraIcon} alt="Scan Icon" />
              </Box>
              <h5 className="step-title" data-i18n="howItWorks.step1.title">
                {i18next.t("Scan your scalp")}
              </h5>
              <p className="step-desc" data-i18n="howItWorks.step1.description">
                {i18next.t(
                  "Follow the AI’s instructions to capture clear images of your scalp and hairline. Our technology is designed to block facial features, ensuring that only your hairline is scanned to protect your privacy."
                )}
              </p>
            </Grid>

            <Grid item xs={12} md={4} sm={4} className="step-box position-relative">
              <Box className="icon-box">
                <img src={imgurl.aiIcon} alt="Analyse Icon" />
              </Box>
              <h5 className="step-title" data-i18n="howItWorks.step2.title">
                {i18next.t("Let Alopexia Analyse your hair")}
              </h5>
              <p className="step-desc" data-i18n="howItWorks.step2.description">
                {i18next.t(
                  "Alopexia AI then matches your hair and scalp with thousands of data points to assess the state of thinning, the health of your scalp, and any other visible hair health conditions."
                )}
              </p>
            </Grid>

            <Grid item xs={12} md={4} sm={4} className="step-box">
              <Box className="icon-box">
                <img src={imgurl.wpforms} alt="Report Icon" />
              </Box>
              <h5 className="step-title" data-i18n="howItWorks.step3.title">
                {i18next.t("Receive your Personalised Report")}
              </h5>
              <p className="step-desc" data-i18n="howItWorks.step3.description">
                {i18next.t(
                  "Receive an in-depth analysis of your hair and scalp, along with personalised, evidence-based hair care recommendations - delivered instantly."
                )}
              </p>
            </Grid>
          </Grid>
        </Box>

       {isMobile && (          
        <div>
             <h6 className='buttonTakeTest mt-20px' onClick={() => {
                  // setTakeTest(true)
                  navigate('/loginpage')
                }}>{i18next.t("Take the AI Hair Test")}</h6>
        </div>
       )}
      </section>

      <section
        ref={sectionRefs.section3}
        id="sample-report-review"
        className="sample-report-review-section"
        style={{ padding: "30px 45px" }}
      >
        <Box className="container section-title" data-aos="fade-up">
          <h2 data-i18n="report.title">{i18next.t("Sample Report Preview")}</h2>
        </Box>

        <Box className="container">
          <Grid container spacing={4}>
            {/* Norwood Scale Assessment */}
            <Grid item md={6} lg={4}>
              <Box className="report-box text-center text-md-start bg-blue-light">
                <h5
                  className="sampleSubHeading"
                  data-i18n="report.norwood.title"
                >
                  {i18next.t("Scale Assessment")}
                </h5>
                <p
                  className="initial-scale"
                  data-i18n="report.norwood.diagnosed"
                >
                  {i18next.t("You've been diagnosed with")}
                </p>
                <Box className="assesmentReport">
                  <img
                    src={imgurl.stageImg}
                    alt="Hair Condition"
                    className="img-fluid my-2"
                  />
                  <Box className="secondtypeSection">
                    <span
                      className="badge-stage"
                      data-i18n="report.norwood.stage3"
                    >
                      {i18next.t("Stage 3")}
                    </span>
                  </Box>
                </Box>
                <p
                  className="mt-3 report-paraDiv"
                  data-i18n="report.norwood.description"
                >
                  {i18next.t(
                    "At this stage there is deep recession at the temples. The alopecia is clearly established but still at a relatively early stage."
                  )}
                </p>
              </Box>
            </Grid>

            {/* Scalp & Hair Insights */}
            <Grid item md={6} lg={4} className="InsightSection">
              <Box className="report-box bg-blue-light insights-second-box">
                <h5
                  className="sampleSubHeading text-center"
                  data-i18n="report.insights.title"
                >
                  {i18next.t("Scalp & Hair Insights")}
                </h5>

                <Grid container spacing={2} mt={2}>
                  <Grid item xs={6}>
                    <Box className="insight-box">
                      <h6 data-i18n="report.insights.hairCount">
                        {i18next.t("Hair Count")}
                      </h6>
                      <p>~80,000</p>
                    </Box>
                  </Grid>
                  <Grid item xs={6}>
                    <Box className="insight-box">
                      <h6 data-i18n="report.insights.hairType">
                        {i18next.t("Type")}
                      </h6>
                      <p data-i18n="report.insights.hairTypeValue">
                        {i18next.t("Straight")}
                      </p>
                    </Box>
                  </Grid>

                  <Grid item xs={6}>
                    <Box className="insight-box">
                      <h6 data-i18n="report.insights.density">
                        {i18next.t("Density")}
                      </h6>
                      <p data-i18n="report.insights.densityValue">
                        {i18next.t("Moderate Density")}
                      </p>
                    </Box>
                  </Grid>
                  <Grid item xs={6}>
                    <Box className="insight-box">
                      <h6 data-i18n="report.insights.dandruff">
                        {i18next.t("Dandruff")}
                      </h6>
                      <p data-i18n="report.insights.dandruffValue">
                        {i18next.t("Not Visible")}
                      </p>
                    </Box>
                  </Grid>

                  <Grid item xs={6}>
                    <Box className="insight-box">
                      <h6 data-i18n="report.insights.inflammation">
                        {i18next.t("Scalp Inflammation")}
                      </h6>
                      <p data-i18n="report.insights.inflammationValue">
                        {i18next.t("Not Visible")}
                      </p>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </Grid>

            {/* Treatment Options */}
            <Grid item md={12} lg={4}>
              <Box className="report-box bg-blue-light insights-third-box">
                <h5
                  className="sampleSubHeading text-center"
                  data-i18n="report.treatment.title"
                >
                  {i18next.t("Treatment options with Hairdresser")}
                </h5>

                <Grid container spacing={2} mt={1}>
                  <Grid item xs={12}>
                    <Box className="insight-box insight-unique-box">
                      <h6 data-i18n="report.treatment.conditioning">
                        {i18next.t("Deep Conditioning & Hydration")}
                      </h6>
                      <p data-i18n="report.treatment.conditioningDesc">
                        {i18next.t(
                          "Consider deep conditioning for dry hair – ask your hairdresser for suitable products."
                        )}
                      </p>
                    </Box>
                  </Grid>

                  <Grid item xs={12}>
                    <Box className="insight-box">
                      <h6 data-i18n="report.treatment.massage">
                        {i18next.t("Scalp Massages And Dermarolling")}
                      </h6>
                      <p data-i18n="report.treatment.massageDesc">
                        {i18next.t(
                          "Use scalp massager and dermaroller to boost scalp health and blood circulation."
                        )}
                      </p>
                    </Box>
                  </Grid>

                  <Grid item xs={12}>
                    <Box className="insight-box">
                      <h6 data-i18n="report.treatment.care">
                        {i18next.t("Hair and scalp care")}
                      </h6>
                      <p data-i18n="report.treatment.careDesc">
                        {i18next.t(
                          "Please use Shampoo without sulphate and avoid harsh dyes or heat treatments"
                        )}
                      </p>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          </Grid>
        </Box>
          {isMobile && (          
        <div>
             <h6 className='buttonTakeTest mt-20px' onClick={() => {
                  // setTakeTest(true)
                  navigate('/loginpage')
                }}>{i18next.t("Take the AI Hair Test")}</h6>
        </div>
       )}
      </section>
    </>
  );
};

export default LandingMiddlePage;
